import { memoize } from 'lodash-es';
import { Store } from '../../../store/player/types';
import { Recording } from '@hotjar/webapp/features/Playbacks/types';

const key = 'noop';
const isReadOnly = memoize(
  (recording: Recording, isLightPlayer: boolean) => {
    return ['write', 'admin'].indexOf(String(recording?.user_access)) === -1 || isLightPlayer;
  },
  () => key,
);

export const readOnly = (store: Store): boolean => {
  const { isLightPlayer, recording } = store.getState();
  if (!isReadOnly.cache.get(key) && !recording) {
    return false;
  }

  return isReadOnly(recording as Recording, isLightPlayer);
};
